export const SetFormData = {
  fromState: (state, formData) => {
    Object.keys(state).forEach(key => {
      formData.append(`data[${key}]`, state[key])
    })
  }
}